import React from "react";
import ExternalLink from '@nerdwallet/react-icon/nerdwallet-ui/ExternalLink';
export default (function () {
  return {
    text: 'Get started',
    showIcon: true,
    icon: /*#__PURE__*/React.createElement(ExternalLink, {
      style: {
        fontSize: '1.25em',
        position: 'absolute',
        top: 'calc(50% - 1.2em/2)'
      }
    }),
    vertical: 'Estate Planning'
  };
});